import { createMuiTheme } from '@material-ui/core/styles';
import mixins from './mixins';
import animation from './settings/animation';
import palette from './settings/palette';
import size from './settings/size';
import typography from './settings/typography';

const theme = createMuiTheme({
  themeName: 'main',
  mixins,
  animation,
  palette,
  size,
  typography,

  overrides: {
    MuiIconButton: {
      root: {
        padding: 8,
        color: 'default',
        fontSize: 12,
      }
    },
    MuiSwitch: {
      switchBase: {
        width: 32,
        height: 32,
      },
    },
    MuiTableRow: {
      root: {
        height: 40,
      }
    },
  },
});

export default theme;
